import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  CircularProgress,
  Alert,
  Paper,
  useTheme
} from '@mui/material';
import CustomCalendar from '../CustomCalendar';
import API_BASE_URL from '../../apiConfig';
import MKTypography from '../MKTypography';

const CalendarSection = () => {
  const theme = useTheme();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCalendarEvents = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/api/events/calendar`);
        if (!response.ok) {
          throw new Error('Failed to fetch calendar events');
        }
        const data = await response.json();
        setEvents(Array.isArray(data) ? data : []);
        setError(null);
      } catch (err) {
        console.error('Error fetching calendar events:', err);
        setError('Failed to load the monthly calendar. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCalendarEvents();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <MKTypography
          variant="h3"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: '#e91e63',
            textShadow: theme.palette.mode === 'dark' ? '2px 2px 4px rgba(0,0,0,0.3)' : '2px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          Monthly Calendar
        </MKTypography>
        <MKTypography
          variant="h6"
          color="text.secondary"
          sx={{ maxWidth: 600, mx: 'auto' }}
        >
          Upcoming events across the San Diego Gaming community
        </MKTypography>
      </Box>

      {events.length === 0 && (
        <Paper
          sx={{
            p: 3,
            mb: 3,
            textAlign: 'center',
            background: theme.palette.mode === 'dark' ? 'rgba(30,30,30,0.9)' : 'rgba(255,255,255,0.9)',
            backdropFilter: 'blur(10px)',
            border: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)'
          }}
        >
          <MKTypography variant="body2" color="text.secondary">
            No events are currently pinned to the calendar. Check back soon!
          </MKTypography>
        </Paper>
      )}

      <Paper sx={{ p: { xs: 2, sm: 3 } }}>
        <CustomCalendar events={events} showEventTitles />
      </Paper>
    </Container>
  );
};

export default CalendarSection;
